"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NameVertex_1 = require("../../lib/graph/vertices/NameVertex");
class CircleNameVertex extends NameVertex_1.NameVertex {
    constructor() {
        super(...arguments);
        this.standardColor = "white"; //"#FFF6F6";
        this.color = this.standardColor;
    }
    draw(ctx, grid) {
        let coord = grid.getCoordinate(this);
        let width = grid.getNodeWidth();
        let height = grid.getNodeHeight();
        ctx.beginPath();
        ctx.strokeStyle = "black";
        ctx.fillStyle = this.color;
        ctx.ellipse(coord[1], coord[0], width, height, 0, 0, 2 * Math.PI);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.lineWidth = 1;
        ctx.textAlign = 'center';
        ctx.fillStyle = 'black';
        let textSize = 4 * grid.getNodeHeight() / 5;
        ctx.font = 'normal ' + textSize + 'px Arial';
        ctx.fillText(this.name, coord[1], coord[0] + textSize / 4);
    }
    inPerimeter(coordinate, grid) {
        let nodeCoordinate = grid.getCoordinate(this);
        let width = grid.getNodeWidth();
        let height = grid.getNodeHeight();
        let dist = Math.pow(coordinate[0] - nodeCoordinate[0], 2)
            + Math.pow(coordinate[1] - nodeCoordinate[1], 2);
        let inP = dist <= width * width || dist <= height * height;
        return inP;
    }
    setColor(color) {
        this.color = color;
    }
    getColor() {
        return this.color;
    }
    resetColor() {
        this.color = this.standardColor;
    }
    keyBoardEvent(k) { }
}
exports.CircleNameVertex = CircleNameVertex;
